"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scroll = exports.MAX_TAB_WIDTH = exports.MIN_TAB_WIDTH = void 0;
exports.MIN_TAB_WIDTH = 40;
exports.MAX_TAB_WIDTH = 200;
const shouldListenTransition = (element, style) => style.transform !== element.style.transform && style.transition !== 'initial';
const invokeAfterElementTransition = (element, callback) => {
    const onStart = () => {
        element.removeEventListener('transitionstart', onStart);
        element.addEventListener('transitionend', onEnd);
        element.addEventListener('transitioncancel', onEnd);
    };
    const onEnd = () => {
        element.removeEventListener('transitionend', onEnd);
        element.removeEventListener('transitioncancel', onEnd);
        callback();
    };
    element.addEventListener('transitionstart', onStart);
};
const getTransformStyles = (index, maxTabsCount, scrollView, scrollPosition, animationDurationMs = 0) => {
    const scrollContainer = scrollView.parentElement;
    if (!scrollContainer) {
        return {};
    }
    const styles = (transform, visibility) => ({
        transition: animationDurationMs > 0
            ? `transform ${animationDurationMs}ms linear`
            : 'initial',
        transform: `translateX(${transform}px)`,
        visibility,
    });
    if (index >= maxTabsCount) {
        return styles(0, 'hidden');
    }
    if (index === 0) {
        return styles(0, 'visible');
    }
    let translate = scrollPosition;
    if (translate < (exports.MIN_TAB_WIDTH - exports.MAX_TAB_WIDTH) * index) {
        translate = (exports.MIN_TAB_WIDTH - exports.MAX_TAB_WIDTH) * index;
    }
    else if (exports.MAX_TAB_WIDTH * index + translate >
        scrollContainer.offsetWidth - exports.MIN_TAB_WIDTH * (maxTabsCount - index)) {
        translate =
            scrollContainer.offsetWidth -
                maxTabsCount * exports.MAX_TAB_WIDTH +
                (exports.MAX_TAB_WIDTH - exports.MIN_TAB_WIDTH) * (maxTabsCount - index);
    }
    else if (translate > 0) {
        translate = 0;
    }
    return styles(translate, 'visible');
};
const allowedTabsCount = (scrollView) => {
    const scrollContainer = scrollView.parentElement;
    if (!scrollContainer) {
        return 0;
    }
    let count = Math.ceil((scrollContainer.offsetWidth - exports.MAX_TAB_WIDTH) / exports.MIN_TAB_WIDTH);
    if (scrollView.children.length < count) {
        return scrollView.children.length;
    }
    return count > 0 ? count : 0;
};
const scroll = (position, ivars, scrollView, animated = false) => {
    return new Promise(onScrollFinish => {
        const scrollContainer = scrollView.parentElement;
        if (!scrollContainer) {
            requestAnimationFrame(onScrollFinish);
            return;
        }
        const isScrollable = scrollContainer.offsetWidth < scrollContainer.scrollWidth;
        if (!isScrollable && ivars.position === 0) {
            requestAnimationFrame(onScrollFinish);
            return;
        }
        const maxTabsCount = allowedTabsCount(scrollView);
        if (isScrollable) {
            const pos = position <= 0 ? position : 0;
            const delta = scrollContainer.offsetWidth - maxTabsCount * exports.MAX_TAB_WIDTH;
            ivars.position = pos >= delta ? pos : delta;
        }
        else if (ivars.position === 0) {
            ivars.updateOverflow(0);
            requestAnimationFrame(onScrollFinish);
            return;
        }
        else {
            ivars.position = 0;
        }
        ivars.updateOverflow(scrollView.children.length - maxTabsCount);
        const mapCallback = (tabElement, index) => new Promise(onTransitionFinish => {
            const styles = getTransformStyles(index, maxTabsCount, scrollView, ivars.position, animated ? 300 : 0);
            if (shouldListenTransition(tabElement, styles)) {
                invokeAfterElementTransition(tabElement, onTransitionFinish);
                Object.assign(tabElement.style, styles);
            }
            else {
                Object.assign(tabElement.style, styles);
                onTransitionFinish();
            }
        });
        const promises = Array.prototype.map.call(scrollView.children, mapCallback);
        Promise.all(promises).then(() => onScrollFinish(0));
    });
};
exports.scroll = scroll;
